import axios from 'axios';
import api from '../../services/api';
import ResponseError from '../../types/response/ResponseError';
import { ResponseData } from '../../types/response/ResponseData';
import { ApiSecret } from '../../types/ApiSecret';

interface ApiSecretData {
    label: string;
    expirationDate: Date | null;
}

export const listApiSecrets = async (
    organizationId: string,
    searchStarted: () => void,
    searchSucceeded: (data: ResponseData<ApiSecret[]>) => void,
    searchFailed: (error: ResponseError) => void
) => {
    searchStarted();

    if (!organizationId) {
        return;
    }

    try {
        const response = await api.get<ResponseData<ApiSecret[]>>(
            `organizations/${organizationId}/apisecrets`
        );

        searchSucceeded(response);
    } catch (error) {
        searchFailed(error as ResponseError);
    }
};

export const createApiSecret = async (
    organizationId: string,
    label: string,
    expirationDate: Date | null,
    creating: () => void,
    created: (data: Record<string, string>) => void,
    searchStarted: () => void,
    searchSucceeded: (data: ResponseData<ApiSecret[]>) => void,
    searchFailed: (error: ResponseError) => void,
    creatingFailed: (error: ResponseError) => void
) => {
    creating();

    try {
        const response = await api.post<ApiSecretData>(
            `organizations/${organizationId}/apisecrets`,
            { label, expirationDate }
        );

        created(response.metadata);
        await listApiSecrets(organizationId, searchStarted, searchSucceeded, searchFailed);
    } catch (error) {
        creatingFailed(error as ResponseError);
    }
};

export const removeApiSecret = async (
    organizationId: string,
    secretId: string,
    removing: () => void,
    removed: () => void,
    searchStarted: () => void,
    searchSucceeded: (data: ResponseData<ApiSecret[]>) => void,
    searchFailed: (error: ResponseError) => void,
    removeFailed: (error: ResponseError) => void
) => {
    removing();

    try {
        await api.del(`organizations/${organizationId}/apisecrets/${secretId}`);

        removed();
        await listApiSecrets(organizationId, searchStarted, searchSucceeded, searchFailed);
    } catch (error) {
        removeFailed(error as ResponseError);
    }
};

